import { APIMethod, fetchData } from "@client";

export async function renameProjectVersionCommentElementQuery(
  projectUuid,
  userUuid,
  versionKey,
  path,
  newName,
) {
  return await fetchData(
    "/v1/ws/project/comments/name",
    APIMethod.PUT,
    {
      mapRequestKeysToSnakeCase: false,
      data: {
        uuid: projectUuid,
        version: versionKey,
        user: userUuid,
        path,
        newName,
      },
    }
  );
}